let paymentSubmissionPreviewPagePromise

export const loadPaymentSubmissionPreviewPage = () => {
  if (!paymentSubmissionPreviewPagePromise) {
    paymentSubmissionPreviewPagePromise =
      import('./payment-submission-preview').catch((error) => {
        paymentSubmissionPreviewPagePromise = undefined
        throw error
      })
  }

  return paymentSubmissionPreviewPagePromise
}

export const preloadPaymentSubmissionPreviewPage = () => {
  // A route navigation can retry if this speculative request fails.
  loadPaymentSubmissionPreviewPage().catch(() => undefined)
}
